<template>
    <component v-on="$listeners" :is="this.href ? 'a' : 'button'" :type="!this.href ? 'button' : ''" :href="this.href" :class="'btn btn-' + (variant || 'primary')">
        <i v-if="this.icon" :class="this.icon + ($slots.default ? ' mr-1' : '' )"></i><slot></slot>
    </component>
</template>
<script>
    export default {
        name: "Button",
        props: ["href", "icon", "variant"]
    }
</script>